import { makeStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import React, { ReactElement } from 'react'

const useStyles = makeStyles(theme => ({
  table: {
    minWidth: 250
  },
  thead: {
    '& th': { fontWeight: 600 }
  },
  value: {
    fontWeight: 600,
    color: theme.palette.primary.main,
    textAlign: 'center'
  }, cell: {
    textAlign: 'center',
  },
}))

export interface LaboratoryRowData {
  name: string
  value?: number | string
  unit: string
  reference: string
  [key: string]: any
}

interface Props {
  rows: LaboratoryRowData[]
  onRowClick?: (row: LaboratoryRowData) => void
}

export default function TableSelectResearch({ rows, onRowClick }: Props) {
  return (
    <React.Fragment>
      <DesctopTable rows={rows} onRowClick={onRowClick} />
    </React.Fragment>
  )
}

function DesctopTable({ rows, onRowClick }: Props): ReactElement {
  const classes = useStyles();
  return (
    <Table
      className={classes.table}
      size='small'
      aria-label='a lab research table'
    >
      <TableHead className={classes.thead}>
        <TableRow>
          <TableCell align='center'>Название</TableCell>
          <TableCell align='center'>Значение</TableCell>
          <TableCell align='center'>ед. изм</TableCell>
          <TableCell align='center'>Норма</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map((row: LaboratoryRowData, index: number) => {
          const formattedValue = row && row.value ? String(row.value).replace(/\n/g, '<br>') : '';
          const formattedReference = row && row.reference ? row.reference.replace(/\n/g, '<br>') : '';

          return (
            <TableRow
              key={index}
              hover
              style={onRowClick ? { cursor: 'pointer' } : undefined}
              onClick={onRowClick ? () => onRowClick(row) : undefined}
            >
              <TableCell component='th' scope='row' padding='none' className={classes.cell}>
                {row && row.name ? row.name : ''}
              </TableCell>
              <TableCell align='center' className={classes.cell}>
                <span dangerouslySetInnerHTML={{ __html: formattedValue }}></span>
              </TableCell>
              <TableCell align='center'>{row && row.unit ? row.unit : ''}</TableCell>
              <TableCell align='center' className={classes.cell}>
                <span dangerouslySetInnerHTML={{ __html: formattedReference }}></span>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
}


